export default {
  loginErr(state) {
    return state.loginErr;
  },
  loggedIn(state) {
    return !!state.data.token;
  },
  userId(state) {
    return state.data.userId;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/users/getters.js